import { queryBuilder } from '~/api';

export const deleteSnapshotSchedule = async (
  scheduleId: number
): Promise<void> => {
  await queryBuilder('DELETE', `snapshot_schedules/${scheduleId}`);
};
